import { render, staticRenderFns } from "./Doka.vue?vue&type=template&id=4c0a0269&"
import script from "./Doka.vue?vue&type=script&lang=js&"
export * from "./Doka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports